export default {
    language: 'Язык',
    english: 'Английский',
    spanish: 'Испанский',
    japanese: 'Японский',
    russian: 'Русский',
    'EDICION DE SECUENCIAS DEL BOTON': 'Редактор последовательностей кнопки',
    'Al seleccionar un icono, no aparecera el texto del boton.': 'При выборе значка текст кнопки не отображается.',
    'Colecciones': 'Коллекции',
    'Solicitudes Colecciones': 'Запросы коллекций',
    'Raspberrys': 'Устройства Raspberry Pi',
    'Buscar Usuarios': 'Поиск пользователей',
    'Solicitudes Amistad': 'Запросы в друзья',
    'Amistades': 'Друзья',
    'OPCIONES': 'НАСТРОЙКИ',
    'Historial Secuencias': 'История последовательностей',
    'Perfil': 'Профиль',
    'Terminos y condiciones': 'Условия использования',
    'Select de idiomas aqui': 'Язык',
    'Cerrar sesión': 'Выйти',
    'Algo salio mal': 'Произошла ошибка',
    'Escriba su correo': 'Введите адрес электронной почты',
    'Entre su contraseña': 'Введите пароль',
    'Entrar': 'Войти',
    'Registrar': 'Зарегистрироваться',
    'Recuperar': 'Восстановить доступ',
    'Bienvenido': 'Добро пожаловать',
    'No se recibió respuesta del servidor': 'Сервер не ответил',
    'Credenciales incorrectas': 'Неверные учетные данные',
    'No se recibió token de autenticación': 'Токен аутентификации не получен',
    'Correo verificado, ya puedes iniciar session.': 'Электронная почта подтверждена. Теперь можно войти.',
    'Entre su Nombre': 'Введите имя',
    'Entre su correo': 'Введите адрес электронной почты',
    'Debes validar el captcha': 'Пройдите проверку CAPTCHA',
    'Usuario creado, confirma desde tu correo.': 'Аккаунт создан. Подтвердите его по электронной почте.',
    'Algo salió mal': 'Произошла ошибка',
    'Error de conexión': 'Ошибка подключения',
    'Verificacion Fallida o Vencida.': 'Проверка не пройдена или срок ее действия истек.',
    'Captcha expirado, verifica nuevamente': 'Срок действия CAPTCHA истек. Пройдите проверку снова.',
    'Cambiar Contraseña': 'Изменить пароль',
    'Digite una nueva contraseña.': 'Введите новый пароль.',
    'Nueva Contraseña': 'Новый пароль',
    'Repita Contraseña': 'Повторите пароль',
    'Enviar': 'Отправить',
    'Cancelar': 'Отмена',
    'Guardar': 'Сохранить',
    'Limpiar': 'Очистить',
    'Cerrar': 'Закрыть',
    'Regresar': 'Назад',
    'Nombre': 'Имя',
    'Correo': 'Электронная почта',
    'Descripcion': 'Описание',
    'Mis amigos': 'Мои друзья',
    'Registrar Amistad': 'Добавить в друзья',
    'Solicitudes de Amistad': 'Запросы в друзья',
    'Complete todos los campos requeridos.': 'Заполните все обязательные поля.',
    'Correo no válido': 'Неверный адрес электронной почты',
    'Nombre demasiado largo': 'Слишком длинное имя',
    'Error en la petición al servidor': 'Ошибка запроса к серверу',
    'Sesión expirada': 'Сеанс истек',
    'Solicitud enviada correctamente': 'Запрос успешно отправлен',
    'Error al enviar la solicitud': 'Не удалось отправить запрос',
    'Solicitud inválida': 'Недействительный запрос',
    'Solicitud aceptada correctamente': 'Запрос принят',
    'Error al aceptar la solicitud': 'Не удалось принять запрос',
    'Denunciar': 'Пожаловаться',
    '¿Desea denunciar': 'Вы хотите пожаловаться',
    'Describa su caso': 'Опишите ситуацию',
    'Captura de pantalla': 'Снимок экрана',
    'El registro se denuncio Exitosamente': 'Жалоба отправлена',
    'Por el momento no hay informacion': 'Пока нет информации',
    'Cargando...': 'Загрузка...',
    'Iconos para el botón': 'Значки кнопки',
    'Tipo de grupo': 'Тип группы',
    'Cantidad de ciclos': 'Количество циклов',
    'Índice Servo': 'Индекс сервопривода',
    'Ángulo': 'Угол',
    'nueva escena': 'Новая сцена',
    'CREACION DE BOTONES': 'СОЗДАНИЕ КНОПОК',
    'Buscar usuarios': 'Поиск пользователей',
    'Icono de la secuencia': 'Значок последовательности',
    'Nombre Secuencia': 'Название последовательности',
    '20 caracteres maximo.': 'Не более 20 символов.',
    'Descripcion Secuencia': 'Описание последовательности',
    'El nombre de la secuencia es obligatorio': 'Укажите название последовательности',
    'Debe seleccionar una colección': 'Выберите коллекцию',
    'La descripción es obligatoria': 'Укажите описание',
    'Debe agregar al menos una escena': 'Добавьте хотя бы одну сцену',
    'Falta tipo en': 'Не указан тип:',
    'Faltan ciclos en': 'Не указано количество циклов:',
    'Falta ángulo en': 'Не указан угол:',
    'El registro se guardó exitosamente': 'Запись сохранена',
    'Hubo un error al guardar la secuencia': 'Не удалось сохранить последовательность',
    'Error en la petición': 'Ошибка запроса',
    'MI PERFIL': 'МОЙ ПРОФИЛЬ',
    'EDITAR INFORMACION DE PERFIL': 'ИЗМЕНИТЬ ДАННЫЕ ПРОФИЛЯ',
    'Imagen de Perfil': 'Изображение профиля',
    'IMAGEN DE PERFIL': 'ИЗОБРАЖЕНИЕ ПРОФИЛЯ',
    'Seleccione una imagen primero': 'Сначала выберите изображение',
    'La imagen se actualizo Exitosamente': 'Изображение обновлено',
    'Raspberry': 'Raspberry Pi',
    'Lanzador de botones': 'Запуск кнопок',
    'Recuperacion de password': 'Восстановление пароля',
    'Las contraseñas no coinciden': 'Пароли не совпадают',
    'Términos aceptados correctamente': 'Условия приняты',
    'No se pudieron aceptar los términos': 'Не удалось принять условия',
    'Secuencias': 'Последовательности',
    '¿Desea Duplicar este registro?': 'Создать копию этой записи?',
    'Duplicar': 'Создать копию',
    '¿Estás seguro de desactivar esta secuencia?': 'Отключить эту последовательность?',
    'Eliminar': 'Удалить',
    'La secuencia fue desactivada': 'Последовательность отключена',
    'No se pudo desactivar la secuencia': 'Не удалось отключить последовательность',
    'Solicitudes de Compartir Colecciones Recibidas': 'Полученные запросы на общий доступ к коллекциям',
    'No hay solicitudes de compartir': 'Нет запросов на общий доступ',
    'Aceptar solicitud': 'Принять запрос',
    'Aceptar': 'Принять',
    'Rechazar solicitud': 'Отклонить запрос',
    'Rechazar': 'Отклонить',
    'Error al cargar las solicitudes': 'Не удалось загрузить запросы',
    'Solicitud rechazada correctamente': 'Запрос отклонен',
    'Visualizar producto': 'Просмотр продукта',
    'Descripcion general': 'Обзор',
    'Usos': 'Применение',
    'Perfil usuario': 'Профиль пользователя',
    'Observaciones': 'Примечания',
    'Cambiar estado': 'Изменить статус',
    'No se pudo obtener la información': 'Не удалось получить информацию',
    'Error al cargar las amistades.': 'Не удалось загрузить список друзей.',
    'Amistad eliminada correctamente': 'Друг удален из списка',
    'Datos actualizados correctamente': 'Данные обновлены',
    'Buscar': 'Поиск',
    'Acciones': 'Действия',
    'Estado': 'Статус',
    'Fecha': 'Дата',
    'Nuevo': 'Новый',
    'nuevo': 'Новый',
    'nombre coleccion': 'Название коллекции',
    'idraspberry': 'ID Raspberry Pi',
    'Cargando datos...': 'Загрузка данных...',
    'Sin raspberry aun.': 'Устройство Raspberry Pi пока не добавлено.',
    'nombre_raspberry': 'Название Raspberry Pi',
    'Descripcion de la Solicitud': 'Описание запроса',
    'Nombre de Raspberry:': 'Название Raspberry Pi:',
    'Hash del dispositivo:': 'Хеш устройства:',
    '¿Desea deshabilitar este registro?': 'Отключить эту запись?',
    'Este proceso no se puede desahacer.': 'Это действие нельзя отменить.',
    'Solicitud actualizada correctamente': 'Запрос обновлен',
    'Registro deshabilitado correctamente': 'Запись отключена',
    'Hash copiado.': 'Хеш скопирован.',
    'Historial Servos': 'История сервоприводов',
    '¿Desea eliminar esta amistad?': 'Удалить этого пользователя из друзей?',
    '¿Eliminar escena completa con todos sus momentos?': 'Удалить всю сцену вместе со всеми шагами?',
    '¿Eliminar servo?': 'Удалить сервопривод?',
    '¿Apagar esta Raspberry?': 'Выключить Raspberry Pi?',
    '¿Reiniciar esta Raspberry?': 'Перезагрузить Raspberry Pi?',
    '¿Estás seguro de desactivar esta coleccion?': 'Отключить эту коллекцию?',
    'Nueva Coleccion': 'Новая коллекция',
    'Nombre de la colección': 'Название коллекции',
    'Nombre de colección': 'Название коллекции',
    'Descripción': 'Описание',
    'Descripcion:': 'Описание:',
    'Nueva Amistad': 'Новый друг',
    'Solicitudes de amistad': 'Запросы в друзья',
    'No hay solicitudes': 'Нет запросов',
    'No se encontraron resultados': 'Результаты не найдены',
    'Colección': 'Коллекция',
    'Coleccion': 'Коллекция',
    'Nombre de la secuencia': 'Название последовательности',
    'Título': 'Заголовок',
    'Titulo': 'Заголовок',
    'Versión': 'Версия',
    'Version': 'Версия',
    'Descripción:': 'Описание:',
    'Cambiar contraseña': 'Изменить пароль',
    'Nueva contraseña': 'Новый пароль',
    'Repita contraseña': 'Повторите пароль',
    'Confirmar': 'Подтвердить',
    'Siguiente': 'Далее',
    'Contraseña actualizada correctamente': 'Пароль обновлен',
    'La contraseña se actualizó correctamente': 'Пароль успешно обновлен',
    'No se pudo guardar la información': 'Не удалось сохранить данные',
    'El registro no se pudo guardar': 'Не удалось сохранить запись',
    '¿Desea desactivar este registro?': 'Отключить эту запись?',
    '¿Está seguro?': 'Вы уверены?',
    'Sin resultados': 'Нет результатов',
    'Página': 'Страница',
    'de': 'из',
    'Nombre:': 'Имя:',
    'Correo:': 'Электронная почта:',
    'Enlazar': 'Связать',
    'Dejar amistad': 'Удалить из друзей',
    'rechazar': 'Отклонить',
    'Solicitud de compartir': 'Запрос на общий доступ',
    'Dispositivo:': 'Устройство:',
    'Conectado': 'Подключено',
    'Desconectado': 'Не подключено',
    'Recibidos:': 'Получено:',
    'Mensajes e interacciones': 'Сообщения и действия',
    'Añadir Momento': 'Добавить шаг',
    'Añadir momento': 'Добавить шаг',
    'RECHAZAR': 'ОТКЛОНИТЬ',
    'Anterior': 'Назад',
    'Ver más': 'Показать больше',
    'Ver menos': 'Показать меньше',
    'Información de la Raspberry': 'Информация о Raspberry Pi',
    'Registrar Raspberry': 'Зарегистрировать Raspberry Pi',
    'Encontrar Hash': 'Найти хеш',
    'Hash raspberry': 'Хеш Raspberry Pi',
    'Nombre Raspberry': 'Название Raspberry Pi',
    'Cancelar solicitud': 'Отменить запрос',
    'Apagado enviado correctamente': 'Команда выключения отправлена',
    'Reinicio enviado correctamente': 'Команда перезагрузки отправлена',
    'Error al enviar comando': 'Не удалось отправить команду',
    'La sesión expiró. Inicie sesión nuevamente.': 'Сеанс истек. Войдите снова.',
    'Algo salió mal:': 'Произошла ошибка:',
    'Error al cargar los datos': 'Не удалось загрузить данные',
    'Solicitudes recibidas': 'Полученные запросы',
    'Secuencia': 'Последовательность',
    'Cambiando idioma…': 'Изменение языка…',
    'nombresecuencia': 'Название последовательности',
    'descripcionsecuencia': 'Описание последовательности',
    'Correlativo': 'Номер записи',
    'Fecha Adjunto': 'Дата вложения',
    'Fecha Estimada': 'Предполагаемая дата',
    'Nombre del archivo': 'Имя файла',
    'Cotización': 'Предложение',
    'Cantidad': 'Количество',
    'Monto presupuestado': 'Запланированная сумма',
    'Actiones': 'Действия',
    'Telefono': 'Телефон',
    'tipo de usuario': 'Тип пользователя',
    'Usuario': 'Пользователь',
    'Tipo': 'Тип',
    'AÃ±adir momento': 'Добавить шаг',
    'Algo saliÃ³ mal:': 'Произошла ошибка:',
    'DescripciÃ³n de la propuesta': 'Описание предложения',
    'El correo es obligatorio': 'Укажите адрес электронной почты',
    'El registro se guardo Exitosamente': 'Запись сохранена',
    'Español': 'Испанский',
    'icono': 'Значок',
    'id': 'ID',
    'Idioma': 'Язык',
    'InformaciÃ³n de la Raspberry': 'Информация о Raspberry Pi',
    'Inglés': 'Английский',
    'Japonés': 'Японский',
    'La contraseña es obligatoria': 'Укажите пароль',
    'La sesiÃ³n expirÃ³. Inicie sesiÃ³n nuevamente.': 'Сеанс истек. Войдите снова.',
    'Máximo de 16 servos': 'Не более 16 сервоприводов',
    'MIS AMISTADES': 'МОИ ДРУЗЬЯ',
    'Recuperación de password': 'Восстановление пароля',
    'status': 'Статус',
    'Ver mÃ¡s': 'Показать больше',
    'Ruso': 'Русский',
    'Ver Coleccion': 'Просмотр коллекции',
    'Compartir colección': 'Поделиться коллекцией',
    'Selecciona un color': 'Выберите цвет',
    'Selecciona Raspberry (hash)': 'Выберите Raspberry Pi (хеш)',
    'nombre_coleccion': 'Название коллекции',
    'Informacion de la Raspberry': 'Информация о Raspberry Pi',
    'Editar Registro': 'Редактировать запись',
    'Deshabilitar Raspberry': 'Отключить Raspberry Pi',
    'No puede ir vacio.': 'Это поле обязательно для заполнения.',
    'No se pudo copiar el hash': 'Не удалось скопировать хеш',
    'Ver registro': 'Просмотр записи',
    'Nuevo Registro': 'Новая запись',
    'Editar registro': 'Редактировать запись',
    'Eliminar registro': 'Удалить запись',
    '¿Seguro que desea eliminar este registro?': 'Вы уверены, что хотите удалить эту запись?',
    'Permisos': 'Права доступа',
    'Matricula': 'Регистрационный номер',
    'Apellido': 'Фамилия',
    'Nivel': 'Уровень',
    'Email': 'Электронная почта',
    '¿Aceptar la solicitud de compartir la colección "{coleccion}" de {usuario}?': 'Принять запрос пользователя {usuario} на общий доступ к коллекции «{coleccion}»?',
    '¿Rechazar la solicitud de compartir la colección "{coleccion}" de {usuario}?': 'Отклонить запрос пользователя {usuario} на общий доступ к коллекции «{coleccion}»?',
    '¿Seguro que deseas dejar la amistad con {usuario}?': 'Вы уверены, что хотите удалить пользователя {usuario} из друзей?',
    'No se pudieron cargar los usuarios': 'Не удалось загрузить пользователей',
    'No se pudieron cargar las colecciones': 'Не удалось загрузить коллекции',
    'No se pudo eliminar la amistad': 'Не удалось удалить пользователя из друзей',
    'No se pudo registrar la Raspberry': 'Не удалось зарегистрировать Raspberry Pi',
    'No se pudo actualizar la Raspberry': 'Не удалось обновить Raspberry Pi',
    'No se pudo deshabilitar la Raspberry': 'Не удалось отключить Raspberry Pi',
    'No se pudo validar el hash de la Raspberry': 'Не удалось проверить хеш Raspberry Pi',
    'Error al enviar la solicitud de compartir': 'Не удалось отправить запрос на общий доступ',
    'Solicitud de compartir enviada correctamente': 'Запрос на общий доступ отправлен',
    'Sesión cerrada correctamente': 'Вы успешно вышли из системы',
};
